import { Title } from '@angular/platform-browser';
import { SidebarService } from './../../service/sidebar.service';
import { SessionService } from './../../service/session.service';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable, Observer } from 'rxjs';
import { _throw } from 'rxjs/observable/throw';
import { CandidateService } from '../../service/candidate.service';
import { HttpClient } from '@angular/common/http';
import { Constants } from '../../constant';

@Injectable()
export class LandingResolver implements Resolve<any> {
  model: any;
  candidates: any[];
  readonly CONSTANTS = Constants;

  constructor(private candidateService: CandidateService,
    private http: HttpClient,
    private sidebarService: SidebarService) {
    this.model = {
      contestDto: [{
        Id: Number,
        BallotTypeId: Number,
        Title: String,
        MaxVotes: Number,
        VotesCast: Boolean,
        SortOrder: Number
      }],
      TotalContests: Number
    };

  }


  getCandidates(contests) {
    let observableBatch = [];

    contests.map((contest, index) => {
      observableBatch.push(this.candidateService.getCandidatesByContestId(contest.Id).map((res: Response) => res));
    });

    return Observable.forkJoin(observableBatch);
  }



  resolve(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<any> {
    this.candidates = [];

    return Observable.create((observer: Observer<any>) => {
      this.http.get('Landing/Index')
        .subscribe((response: any) => {
          if (response.status === 200) {


            this.model = response.model;
            var contestList = this.model.BallotData.Contests;
            var totalContests = this.model.BallotData.TotalContests;
            if (totalContests > 0) {
              this.getCandidates(contestList).subscribe(
                (response: any) => {
                  if (response) {
                    response.map((res, index) => {
                      if (res.status === 200) {
                        this.candidates.push({
                          MaxVotes: contestList[index].MaxVotes,
                          Candidates: res.model['Candidates'],
                          SelectionCount: 0,
                          BallotTitle: contestList[index].Title
                        });
                      }
                    });

                  }
                  else { throw new Error('Error something went wrong!'); }
                });
            }
            else { throw new Error('Error something went wrong!') };

            setTimeout(() => {
              this.sidebarService.setContest(contestList);
              observer.next(this.candidates)
              observer.complete()
            }, 1000);


          }

        }, err => observer.error(err))
    })

  }

}






// WEBPACK FOOTER //
// ./src/app/features/landing/landing.resolver.ts